/** @format */

import template from './gb-add-raffle-draw-widget.html';

export const GbAddRaffleDrawWidgetComponent = {
    template,
    require: {
        gbApp: '^^',
        gbPresenter: '^^',
    },
    bindings: {
        widget: '=',
    },
    controller: class GbAddRaffleDrawWidgetComponent {
        constructor($gbRaffleDrawProjectorWidget, $ccColors) {
            'ngInject';

            this.$gbRaffleDrawProjectorWidget = $gbRaffleDrawProjectorWidget;
            this.$ccColors = $ccColors;
        }

        addWidget() {
            let primaryBgColor = this.gbApp.getAuction().primary_color;
            let accentBgColor = this.gbApp.getAuction().accent_color;

            let widget = new this.$gbRaffleDrawProjectorWidget({
                x: 35,
                y: 5,
                x_unit: '%',
                y_unit: '%',
                width: 30,
                width_unit: '%',
                height: 20,
                height_unit: '%',
                opacity: 1,
                primary_color: primaryBgColor,
                // primary_text_color: this.$ccColors.getContrast(primaryBgColor),
                accent_color: accentBgColor,
                // accent_text_color: this.$ccColors.getContrast(accentBgColor),
                font_size: 50,
            });

            this.gbPresenter.tempWidgets.push(widget);
        }
    },
};
